// extracted by mini-css-extract-plugin
module.exports = {"container":"video-thumbnail_container_1ZDzx","videoThumbnail":"video-thumbnail_videoThumbnail_2V0f9","play":"video-thumbnail_play_jl1k7"};